import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux'
import InputField from '../../../../helpers/Fields/InputField';
import { required, email } from 'redux-form-validators'
import PropTypes from 'prop-types'
import { createRoom, updateRoom } from '../../../actions';
import DateField from '../../../../helpers/Fields/DateField';
import { Checkbox } from 'antd';
import SwitchField from '../../../../helpers/Fields/SwitchField';
import {toastr} from 'react-redux-toastr'
import moment from 'moment';
import { CirclePicker } from 'react-color';


class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      hasPassoword: props.initialValues.password
    }
  }
  

  submit = async (values)=> {
    try {
      const {formatMessage} = this.context;
      const {handleClose} = this.props;
      const {hasPassoword} = this.state;
      if(!hasPassoword){
        values.password = '';
      }

      if(moment() > moment(values.active_to)){
        toastr.warning(formatMessage('msgWarningPublic'), formatMessage('msgWarningPublicMessage'));
        return;
      }

      if(values.id){
        await this.props.updateRoom(values);
        toastr.success(formatMessage('msgNotificationTitleRoomCreaded'), formatMessage('msgNotificationRoomCreated'))

      } else {
        await this.props.createRoom(values);
        toastr.success(formatMessage('msgNotificationTitleRoomUpdated'), formatMessage('msgNotificationRoomUpdated'))
      }
      
      handleClose();
    } catch (error) {
    }
    
  }

  render() {
    const {formatMessage} = this.context
    let { handleSubmit, handleClose, initialValues, valuesForm } = this.props;
    if(!valuesForm){
      valuesForm = {};
    }
    return (
      <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='title'
          label={formatMessage('txtCaptionClassRoomName')}
          component={InputField}
          validate={[required()]}
        />
        <div className="form__form-group" style={{marginBottom: !this.state.hasPassoword ? '20px' : '5px',}}>
          <Checkbox checked={this.state.hasPassoword} onChange={() => {
            this.setState({hasPassoword: !this.state.hasPassoword});
          }}>{formatMessage('txtCaptionClassRoomPassword')}</Checkbox>
        </div>

        {this.state.hasPassoword ? <Field 
          name='password'
          component={InputField}
          validate={[required()]}
          
        /> : null}

        <Field 
          name='status'
          label={formatMessage('txtCaptionPublicationStatus')}
          component={SwitchField}
          trueTitle={formatMessage('txtCaptionPublished')}
          falseTitle={formatMessage('txtCaptionUnpublished')}
          handleClick={(value, input) => {
            if(value){
              if(moment() > moment(valuesForm.active_to)){
                toastr.warning(formatMessage('msgWarningPublic'), formatMessage('msgWarningPublicMessage'))
              } 
            }
            input.onChange(value);
          }}
        />

        <Field 
          name='active_from'
          label={formatMessage('txtCaptionAvailableFrom')}
          component={DateField}
          onHandleChange={(value, input) => {
            input.onChange(value);
            if(value > moment(valuesForm.active_to)){
              this.props.change('active_to', value)
            }
          }}
          validate={[required()]}
          inputProps={{
            format: "DD MMM YYYY",
            disabledDate: (current) => (current && current <= moment().endOf('day').subtract(1, 'day'))
          }}
          inputPropsTime={{
            disabledHours: () => {
              const hours = new Date().getHours();
              const disabledH = [];
              for(const [index] of Array(hours).entries()){
                disabledH.push(index)
              }
              return disabledH
            },
            disabledMinutes: () => {
              const minutes = new Date().getMinutes();
              const disabledM = [];
              for(const [index] of Array(minutes).entries()){
                disabledM.push(index)
              }
              return disabledM
            },
            disabledSeconds: () => {
              const sec = new Date().getSeconds();
              const disabledS = [];
              for(const [index] of Array(sec).entries()){
                disabledS.push(index)
              }
              return disabledS
            }
          }}
        />

        <Field 
          name='active_to'
          label={formatMessage('txtCaptionAvailableUntil')}
          component={DateField}
          validate={[required()]}
          inputPropsTime={{
            disabledHours: () => {
              
              if(moment(valuesForm.active_to).format('MM/DD/YY') == moment(valuesForm.active_from).format('MM/DD/YY')) {
                const hours = moment(valuesForm.active_from).toDate().getHours();
                const disabledH = [];
                for(const [index] of Array(hours).entries()){
                  disabledH.push(index)
                }
                return disabledH
              }
              return [];
              
            },
            disabledMinutes: () => {
              if(moment(valuesForm.active_to).format('MM/DD/YY') == moment(valuesForm.active_from).format('MM/DD/YY')) {
                const minutes = moment(valuesForm.active_from).toDate().getMinutes();
                const disabledM = [];
                for(const [index] of Array(minutes).entries()){
                  disabledM.push(index)
                }
                return disabledM
              }
              return [];
            },
            disabledSeconds: () => {
              if(moment(valuesForm.active_to).format('MM/DD/YY') == moment(valuesForm.active_from).format('MM/DD/YY')) {
                const sec = moment(valuesForm.active_from).toDate().getSeconds();
                const disabledS = [];
                for(const [index] of Array(sec).entries()){
                  disabledS.push(index)
                }
                return disabledS;
              }
              return [];
            }
          }}
          inputProps={{
            format: "DD MMM YYYY",
            disabledDate: (current) => (current && current < moment(valuesForm.active_from))
          }}
        />

        <div className="form__form-group">
          <label>{formatMessage('txtCaptionRoomColor')}</label>
          <CirclePicker
            color={ valuesForm.color }
            onChangeComplete={(color) => {
              this.props.change('color', color.hex)
            }}
            colors={[
              "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#ddd"
            ]}
          />
        </div>
        
        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancelRoom')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreateRoom': 'btnModalUpdateRoom')}</button>
        </div>
         
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_task',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_task')(state)
})

const mapDispatchToProps = {
  createRoom,
  updateRoom,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContent);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/Rooms/components/FormModal/FormContent.jsx